import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";

  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!token) { setErr("Falta el token. Solicita un enlace nuevo."); return; }
    if (next.length < 8) { setErr("Mínimo 8 caracteres."); return; }
    if (next !== confirm) { setErr("Las contraseñas no coinciden."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: next });
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gb-black text-white" data-testid="reset-password-page">
      <main className="mx-auto max-w-md px-6 py-16">
        <p className="text-[11px] uppercase tracking-[0.4em] text-gb-red">grabarte · studio</p>
        <h1 className="mt-2 gb-display text-3xl">Crear nueva contraseña</h1>
        <p className="mt-3 text-sm text-white/65">Introduce una nueva contraseña para tu cuenta.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="block text-[11px] uppercase tracking-[0.3em] text-white/55">Nueva contraseña (mín. 8)</label>
            <input type="password" autoComplete="new-password" required autoFocus
                   value={next} onChange={(e) => setNext(e.target.value)}
                   data-testid="rp-new"
                   className="mt-2 w-full rounded-md border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none transition focus:border-gb-red" />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[0.3em] text-white/55">Confirma la nueva contraseña</label>
            <input type="password" autoComplete="new-password" required
                   value={confirm} onChange={(e) => setConfirm(e.target.value)}
                   data-testid="rp-confirm"
                   className="mt-2 w-full rounded-md border border-white/15 bg-white/5 px-3 py-2 text-sm outline-none transition focus:border-gb-red" />
          </div>

          {err && <p className="rounded bg-red-500/10 px-3 py-2 text-sm text-red-200" data-testid="rp-error">{err}</p>}
          {done && <p className="rounded bg-emerald-500/10 px-3 py-2 text-sm text-emerald-200" data-testid="rp-ok">Contraseña actualizada. Llevándote al login…</p>}

          <button type="submit" disabled={busy} data-testid="rp-submit"
                  className="w-full rounded-full bg-gb-red px-5 py-3 text-sm font-semibold uppercase tracking-widest text-white transition hover-gb-red disabled:opacity-40">
            {busy ? "Guardando…" : "Guardar contraseña"}
          </button>

          <Link to="/login" className="block text-center text-[12px] text-white/60 transition hover:text-white">← Volver al login</Link>
        </form>
      </main>
    </div>
  );
}
